import Crud from '@/views/DutyShift/Crud'

const routes = {
  path: '/plantoes',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/plantoes',
      name: 'Plantões',
      component: Crud,
    },
  ],
}

export default routes
